/** @format */

// import { debounce } from 'lodash';
import { $utils } from '@/utils/publicUtils';

export default {
	props: {
		/**
		 * 是否显示过滤切换的标签
		 */
		showFilterLabel: {
			type: Boolean,
			default: true,
		},
		isTree: {
			type: Boolean,
			default: false,
		},
		/**
		 *  尺寸
		 */
		size: {
			type: String,
		},
		/**
		 * @description 工具栏
		 */
		toolbars: {
			type: [Array, Boolean],
		},
		/**
		 * @description 搜索工具栏
		 */
		searchToolbars: {
			type: [Array, Boolean],
			default: () => {
				return [
					// 备注： label 因国际化问题先在这里写上名称了
					{ code: 'search', label: '查询', type: 'primary', size: 'default' },
					{ code: 'resetSearch', plain: 'plain', label: '重置', size: 'default' },
				];
			},
		},
		/**
		 * @description 查询表单
		 */
		searchForm: {
			type: Object,
		},
		searchSlot: {
			type: Boolean,
			default: false,
		},
		/**
		 *  @description 表格标题
		 */
		title: {
			type: String,
			default: '',
		},
		/**
		 * @description 主键
		 */
		pkKey: {
			type: String,
		},
		rowKey: {
			// 行数据的 Key
			type: [String, Function],
		},
		/**
		 * @description 唯一标识
		 */
		unique: {
			type: String,
		},
		/**
		 * @description 表头数据
		 */
		columns: {
			type: Array,
			required: true,
		},
		/**
		 * @description 表格加载
		 */
		loading: {
			type: Boolean,
			default: false,
		},
		/**
		 * @description 表格加载配置
		 */
		loadingOptions: {
			type: Object,
			default: null,
		},
		/**
		 * @description 表格配置
		 */
		options: {
			type: Object,
			default: () => {
				return {
					border: true,
					stripe: false,
				};
			},
		},
		/**
		 * @description 索引
		 */
		indexRow: {
			type: [Object, Boolean],
			default: true,
		},
		/**
		 * @description 多选
		 */
		selectionRow: {
			type: [Object, Boolean],
			default: true,
		},
		/**
		 * @description 类型
		 * [可选值] radio/checkbox
		 */
		selectionType: {
			type: String,
			default: 'checkbox',
		},
		/**
		 * 是否受权限控制
		 */
		accessControl: {
			type: Boolean,
			default: true,
		},
		/**
		 * @description 标识
		 * 标识这个列表
		 */
		identity: {
			type: String,
		},
		/**
		 *
		 * 预留关闭按钮位置
		 */
		buttonSpace: {
			type: Boolean,
			default: false,
		},
		gapPlacementParam: {
			type: Array,
			default: [],
		},
	},
	computed: {
		tableOptions() {
			let _options = {};
			if ($utils.isNotEmpty(this.options)) {
				_options = JSON.parse(JSON.stringify(this.options));
			}
			if (this.rowKey) {
				_options.rowKey = this.rowKey;
			} else {
				let _key = this.pkKey;
				if ($utils.isNotEmpty(this.unique)) _key = this.unique;
				if (this.showRowKey && $utils.isNotEmpty(_key)) {
					_options.rowKey = _key;
				}
			}

			return _options;
		},
	},
	methods: {
		setSelectionRadio(row) {
			this.$selections = row ? [row] : [];
			const radio = row ? this.getPkValue(row) : '';
			if (radio !== this.selectionRadio) {
				this.selectionRadio = radio;
			}
		},
		clearSelection() {
			if (this.selectionType === 'radio') {
				this.setSelectionRadio();
			} else {
				this.$refs.elTable.clearSelection();
			}
		},
		toggleRowSelection(row, selected) {
			if (this.selectionType !== 'radio') {
				this.$refs.elTable.toggleRowSelection(row, selected);
			}
		},
		toggleAllSelection() {
			this.$refs.elTable.toggleAllSelection();
		},
		toggleSelectionRow(row, selected) {
			const pkValue = this.getPkValue(row);
			for (let i = 0; i < this.ibpsData.length; i++) {
				const data = this.ibpsData[i];
				if (this.getPkValue(data) === pkValue) {
					this.$refs.elTable.toggleRowSelection(data, selected);
				}
			}
		},
		/**
		 * @description 处理工具栏收缩/展开
		 */
		handleCollapseExpandToolbar(downOrUp) {
			this.handleTableHeight(true, downOrUp);
			this.$emit('collapse-expand-toolbar', downOrUp);
		},
		/**
		 * @description 行选中状态
		 */
		handleCurrentChange(currentRow, oldCurrentRow) {
			this.$emit('current-change', currentRow, oldCurrentRow);
		},
		/**
		 * @description 勾选数据时触发的事件
		 */
		handleSelect(selection, row) {
			this.$emit('select', selection, row);
		},
		/**
		 * @description 勾选全选时触发的事件
		 */
		handleSelectAll(selection) {
			this.$emit('select-all', selection);
		},
		/**
		 * @description 复选框选择项发生变化时触发的事件
		 */
		handleSelectionChange(selection) {
			// 原来的
			// this.$selections = selection
			// 改造的
			this.$refs.ibpsCrud.$selections = selection;
			this.$emit('selection-change', selection);
		},
		/**
		 * @description 单元格 hover 进入时触发的事件
		 */
		handleCellMouseEnter(row, column, cell, event) {
			this.handleOperationMenuEnter(row, column, cell, event);
			this.$emit('cell-mouse-enter', row, column, cell, event);
		},
		/**
		 * @description 单元格 hover 退出时触发的事件
		 */
		handleCellMouseLeave(row, column, cell, event) {
			this.handleOperationMenuLeave(row, column, cell, event);
			this.$emit('cell-mouse-leave', row, column, cell, event);
		},
		/**
		 * @description 单元格点击时触发的事件
		 */
		handleCellClick(row, column, cell, event) {
			this.$emit('cell-click', row, column, cell, event);
		},
		/**
		 * @description 单元格双击时触发的事件
		 */
		handleCellDblclick(row, column, cell, event) {
			this.$emit('cell-dblclick', row, column, cell, event);
		},
		/**
		 * @description 行点击时触发的事件
		 */
		handleRowClick(row, event, column) {
			if (this.selectionType === 'radio') {
				this.setSelectionRadio(row);
				this.$emit('selection-change', row);
			} else {
				// 备注：多选时点击行会清空选择的数据，先注释掉
				// this.$refs.elTable.clearSelection();
				this.$refs.elTable.toggleRowSelection(row);
			}
			this.$emit('row-click', row, event, column);
		},
		/**
		 * @description 行右键点击时触发的事件
		 */
		handleRowContextmenu(row, event) {
			this.$emit('row-contextmenu', row, event);
		},
		/**
		 * @description 行双击时触发的事件
		 */
		handleRowDblclick(row, event) {
			this.$emit('row-dblclick', row, event);
		},
		/**
		 * @description 表头点击时触发的事件
		 */
		handleHeaderClick(column, event) {
			this.$emit('header-click', column, event);
		},
		/**
		 * @description 当拖动表头改变了列的宽度的时候会触发该事件
		 */
		handleHeaderDragend(newWidth, oldWidth, column, event) {
			// debounce(this.handleTableHeight, 100)();
			this.$emit('header-dragend', newWidth, oldWidth, column, event);
		},

		/**
		 * @description 表头右键点击时触发的事件
		 */
		handleHeaderContextmenu(column, event) {
			this.$emit('header-contextmenu', column, event);
		},
		/**
		 * @description 处理按钮的事件 【包含增删改查】
		 * @param {*} button
		 * @param {*} position
		 * @param {*} data
		 */
		handleActionEvent(action, position, data, index) {
			if (position === 'toolbar') {
				// 原先的
				// data = this.$selections
				// 改造的
				data = this.$refs.ibpsCrud.$selections;
			}
			if (action.emit) {
				this.$emit(action.emit, {
					code: action.code,
					index,
					row: data,
					position,
					action,
				});
			}
			const buttonKey = action.code;
			let selection = null; // 选中数据
			if (position === 'toolbar') {
				// 工具栏
				selection = this.getSelectedIds();
			} else {
				// 管理列
				selection = data ? this.getPkValue(data) : null;
			}
			if ($utils.isArray(data)) {
				for (let i = 0; i < data.length; i++) {
					const dataObj = data[i];
					if ($utils.isNotEmpty(this.getPkLabel(dataObj)) && this.getPkLabel(dataObj) !== 'draft') {
						if (action.code === 'edit' || action.code === 'remove') {
							this.$message({
								message: '不能操作已提交审批的单据',
								type: 'warning',
							});
							return;
						}
					}
				}
			}
			this.$emit('action-event', buttonKey, position, selection, data, index, action);
		},

		/**
		 * 根据key获取对象的值
		 * 用于解决key值大小写不同的问题
		 * @param {Object} data 需要从中获取值的对象
		 */
		getPkValue(data, defaultValue = '') {
			const pkKey = this.pkKey || 'id';
			// 创建一个忽略大小写的正则对象
			const regx = new RegExp(`^${pkKey}$`, 'gi');
			// 循环正则匹配
			for (const key in data) {
				// 匹配成功返回值
				if (regx.test(key)) {
					return data[key];
				}
			}
			return defaultValue;
		},
		getPkLabel(data, defaultValue = '') {
			const pkKey = 'flow_status_';
			for (const key in data) {
				// 匹配成功返回值
				if (key.indexOf(pkKey) !== -1) {
					return data[key];
				}
			}
			return defaultValue;
		},
		/**
		 * @description 获取选中的值
		 */
		getSelectedIds() {
			if (this.selectionType === 'radio') {
				if (this.selectionRadio === null || this.selectionRadio === undefined) {
					return;
				}
				return this.selectionRadio;
			} else {
				// 原先的
				// if (this.$selections === null || this.$selections === undefined) {
				//   return
				// }
				// const ids = []
				// this.$selections.map((item) => {
				//   ids.push(this.getPkValue(item))
				// })
				// return ids

				// 改造的
				if (this.$refs.ibpsCrud.$selections === null || this.$refs.ibpsCrud.$selections === undefined) {
					return;
				}
				const ids = [];
				this.$refs.ibpsCrud.$selections.map((item) => {
					ids.push(this.getPkValue(item));
				});
				return ids;
			}
		},
	},
};
